// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3s58l","location":"Header_location__3hWtD"};